<ng-container *ngrxLet="combined$; let combined">
  @if (combined.loaderStatus) {
    <app-preloader></app-preloader>
  }

  @if (!combined.isWidget || !combined.isFetchingWidget) {
    <router-outlet></router-outlet>
  }

  <audio
    controls
    preload="auto"
    class="audio-element"
    [volume]="0.1"
    #audioElement
    src="/assets/bell.mp3"
  ></audio>
</ng-container>
